// Funções de formatação e validação para garantias

/**
 * Formata telefone brasileiro no padrão (99) 99999-9999
 */
export function formatPhoneBR(value: string): string {
  // Remove todos os caracteres não-numéricos
  const numericValue = value.replace(/\D/g, '');
  
  // Limita a 11 dígitos
  const limitedValue = numericValue.slice(0, 11);
  
  // Formata conforme o tamanho
  if (limitedValue.length === 0) return '';
  if (limitedValue.length <= 2) return `(${limitedValue}`;
  if (limitedValue.length <= 6) return `(${limitedValue.slice(0, 2)}) ${limitedValue.slice(2)}`;
  if (limitedValue.length <= 10) return `(${limitedValue.slice(0, 2)}) ${limitedValue.slice(2, 6)}-${limitedValue.slice(6)}`;
  return `(${limitedValue.slice(0, 2)}) ${limitedValue.slice(2, 7)}-${limitedValue.slice(7)}`;
}

/**
 * Formata CPF brasileiro no padrão 999.999.999-99
 */
export function formatCPF(value: string): string {
  // Remove todos os caracteres não-numéricos
  const numericValue = value.replace(/\D/g, '');
  
  // Limita a 11 dígitos
  const limitedValue = numericValue.slice(0, 11);
  
  // Formata conforme o tamanho: 999.999.999-99
  if (limitedValue.length === 0) return '';
  if (limitedValue.length <= 3) return limitedValue;
  if (limitedValue.length <= 6) return `${limitedValue.slice(0, 3)}.${limitedValue.slice(3)}`;
  if (limitedValue.length <= 9) return `${limitedValue.slice(0, 3)}.${limitedValue.slice(3, 6)}.${limitedValue.slice(6)}`;
  return `${limitedValue.slice(0, 3)}.${limitedValue.slice(3, 6)}.${limitedValue.slice(6, 9)}-${limitedValue.slice(9)}`;
}

/**
 * Valida CPF usando algoritmo de validação
 */
export function validateCPF(cpf: string): boolean {
  // Remove caracteres não-numéricos
  const cleanCPF = cpf.replace(/\D/g, '');
  
  // Deve ter 11 dígitos
  if (cleanCPF.length !== 11) {
    return false;
  }
  
  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cleanCPF)) {
    return false;
  }
  
  // Validação do primeiro dígito verificador
  let sum = 0;
  let remainder;
  
  for (let i = 1; i <= 9; i++) {
    sum += parseInt(cleanCPF.substring(i - 1, i)) * (11 - i);
  }
  
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }
  
  if (remainder !== parseInt(cleanCPF.substring(9, 10))) {
    return false;
  }
  
  // Validação do segundo dígito verificador
  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum += parseInt(cleanCPF.substring(i - 1, i)) * (12 - i);
  }
  
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }
  
  if (remainder !== parseInt(cleanCPF.substring(10, 11))) {
    return false;
  }
  
  return true;
}

/**
 * Retorna mensagem de erro para CPF inválido
 */
export function getCPFErrorMessage(cpf: string): string {
    const cleanCPF = cpf.replace(/\D/g, '');

    if (!cpf || cleanCPF.length !== 11) {
        return '';
    }
  
  
//   if (cleanCPF.length !== 11) {
//     return `CPF incompleto: ${cleanCPF.length}/11 dígitos`;
//   }
  
  if (/^(\d)\1{10}$/.test(cleanCPF)) {
    return 'CPF inválido: todos os dígitos são iguais';
  }
  
  if (!validateCPF(cpf)) {
    return 'CPF inválido, verifique os dados';
  }
  
  return '';
}

/**
 * Valida telefone brasileiro
 */
export function validatePhone(phone: string): boolean {
  const cleanPhone = phone.replace(/\D/g, '');
  return cleanPhone.length === 11;
}
